/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BatchMoveEtcResponse,
    BatchMoveEtcResponseFromJSON,
    BatchMoveEtcResponseFromJSONTyped,
    BatchMoveEtcResponseToJSON,
} from './BatchMoveEtcResponse';

/**
 * 
 * @export
 * @interface BatchMoveResponse
 */
export interface BatchMoveResponse {
    /**
     * 
     * @type {BatchMoveEtcResponse}
     * @memberof BatchMoveResponse
     */
    etc: BatchMoveEtcResponse;
}

export function BatchMoveResponseFromJSON(json: any): BatchMoveResponse {
    return BatchMoveResponseFromJSONTyped(json, false);
}

export function BatchMoveResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchMoveResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'etc': BatchMoveEtcResponseFromJSON(json['etc']),
    };
}

export function BatchMoveResponseToJSON(value?: BatchMoveResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'etc': BatchMoveEtcResponseToJSON(value.etc),
    };
}

